import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/currency-appreciation-calculator',
  component: () => import('../../routes/CurrencyAppreciation.svelte'),
  card: {
    id: 'currency-appreciation',
    title: 'Currency Appreciation Calculator',
    description: 'Calculate how much one currency gains or loses value against another over time, with annualized rate and year-by-year breakdown.',
    icon: 'currency_exchange',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/currency-appreciation-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Currency Appreciation Calculator – Forex Gain/Loss & Annualized Rate',
    description: 'Free currency appreciation calculator. Calculate how much one currency gains or loses value against another over time. Compute annualized appreciation rate, purchasing power changes, and year-by-year breakdown.',
  },
};

export default meta;